import './App.css';
import '@fontsource/work-sans';
import './styles/global.css';
/* eslint-disable react/prop-types */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { initVersionCheck, stopVersionCheck } from './Utils/versionManager';
import AdminSignup from './Pages/Admin-signup/Admin-signup';
import AdminLogin from './Pages/Admin-login/Admin-login';
import AdminDashboard from './Pages/Admin-Dashboard/Admin-Dashboard';
import TrainingGuard from './Pages/Admin-Dashboard/training-guard';
import DashboardDetails from './Pages/Dashboard-Details/Dashboard-Details';
import ForgotPassword from './Pages/Admin-login/Forgot-Password';
import ChangePassword from './Pages/Admin-login/forced-password';
import CustomerDetails from './Pages/Customer/customer-detail';
import MyProfile from './Pages/Customer/profile';
import { ToastProvider } from '../src/Utils/toastContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MultiStepSidebarForm from './Pages/Onboarding/multi-step-sidebar-form';
import MultiStepSidebarFormShareholder from './Pages/Onboarding-shareholder/multi-step-sidebar-form';
import AgentDetails from './Pages/Agents/agent-detail';
import AgencyDetails from './Pages/Agency/agency-detail';
import AgentList from './Pages/Agent/agent-list';
import ComplianceOfficer from './Pages/Agents/compilance-officer-detail';
import ComplianceDetails from './Pages/Agents/compliance-officer-profile';
import AuditorDetails from './Pages/Auditor-Management/auditor-details';

import AuditorList from './Pages/Auditor-Management/auditor-list';
import ReviewKyc from './Pages/kycs/review-kyc';
import ReviewKycReadOnly from './Pages/kycs/review-kyc-read-only';
import ReviewKycJointAccount from './Pages/kycs/review-kyc-joint-account';
import ReviewKycJointAccountReadOnly from './Pages/kycs/review-kyc-joint-account-read-only';

import ReviewKYCCorporate from './Pages/kycs/review-kyc-corporate';
import ReviewKYCCorporateReadOnly from './Pages/kycs/review-kyc-corporate-read-only';
import ReviewKYCTrust from './Pages/kycs/review-kyc-trust';
import ReviewKYCTrustReadOnly from './Pages/kycs/review-kyc-trust-read-only';

import ReviewKycShareholder from './Pages/kycs/review-kyc-shareholder';
import ReviewKycShareholderReadOnly from './Pages/kycs/review-kyc-shareholder-read-only';
import ReviewKycShareholderTrust from './Pages/kycs/review-kyc-shareholder-trust';
import ReviewKycShareholderTrustReadOnly from './Pages/kycs/review-kyc-shareholder-trust-read-only';

import CustomerList from './Pages/People-Management/customer-list';
import BusinessList from './Pages/Business-List/business-list';
import BusinessDetails from './Pages/Business-List/business-detail';
import AgencyList from './Pages/Agency/agency-list';
import ReviewKycAgent from './Pages/kycs/review-kyc-agent';
import EDDCustomer from './Pages/Risk-Assessment/edd-customer-response';
import EDDStakeholder from './Pages/Risk-Assessment/edd-stakeholder-response';
import SurveyQuestion from './Pages/Survey/survey-question';
import SurveyList from './Pages/Survey/survey-list';
import StaffTraining from './Pages/Training/training-list';
import OngoingMonitoringModule from './Pages/Ongoing-Monitor/ongoing-monitor';
import RiskAssessmentQuestionManagement from './Pages/Risk-Assessment/risk-assessment';
import CertificateEntry from './Pages/Share-Certificates/CertificateEntry';
import CertificateAction from './Pages/Share-Certificates/CertificateAction';
import TransactionsSection from './Pages/Customer-Transaction/transaction-details';
import ContactUs from './Pages/Contact-Us/contact-us';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthRouterController from './Components/Header/AuthRouterController';
import PaymentSubsribe from './Pages/Subscription/payment-details';
import PrivacyPolicyViewer from './Pages/Privacy-Policy/privacy-policy';
import NotFound from './Pages/Admin-Dashboard/not-found';
import LandingPage from './Pages/Landing-Page/landing-page';
import LandingPageDashbaord from './Pages/Landing-Page/landing-page-dashboard';
import TicketList from './Pages/Contact-Us/ticket-list';
import CreateContract from './Pages/Contract-Managment/main-page';
import TemplateDashboard from './Pages/Template-Management/template-dashboard';
import DocumentDetailsOwner from './Pages/Template-Management/Document-Details/document-details-view';

import TemplateEditor from './Pages/Template-Management/Template-Editor/template-editor';
import TemplateViewer from './Pages/Template-Management/Template-Viewer/template-viewer';
import CustomerTemplateViewer from './Pages/Template-Management/Template-Viewer/customer-template-viewer';

import AgentTemplateViewer from './Pages/Template-Management/Template-Viewer/agent-template-viewer';
import AgentContractReassign from './Pages/Template-Management/Template-Viewer/agent-reassign-contract';

import TemplateCreator from './Pages/Template-Management/Template-Creator/template-creator';
import ContractHub from './Pages/Contract-Managment/Contract-Manager/contract-hub';
import ContractDetailsFullScreen from './Pages/Contract-Managment/Contract-Manager/contract-details';
import ReportGenerator from './Pages/Report-Management/generate-report';
import ContractList from './Pages/Customer-Contract-Management/contract-list';
import MyPricingPlan from './Pages/PricingPlan/my-pricing-plan';
import InvoiceDetailScreen from './Pages/PricingPlan/invoice-detail-screen';
import RolePermission from './Pages/Role-Permissions/role-permissions';
import PeoplePage from './Pages/People-Management/people-page';
import Certificates from './Pages/Certificates/certificates';
import MemberList from './Pages/Member-Management/member-list';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('jwtToken');
  return token ? children : <Navigate to="/login" />;
};
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
function App() {
  // Initialize version checking to auto-refresh on new deployments
  useEffect(() => {
    initVersionCheck();

    return () => {
      stopVersionCheck();
    };
  }, []);

  useEffect(() => {
    const checkIndexCache = async () => {
      try {
        // Fetch index.html directly from server
        const response = await fetch('/index.html', {
          method: 'GET',
          cache: 'no-store', // ensure we get latest
        });

        console.log('--- index.html headers ---');
        console.log('Status:', response.status);
        console.log('Cache-Control:', response.headers.get('Cache-Control'));
        console.log('Pragma:', response.headers.get('Pragma'));
        console.log('Expires:', response.headers.get('Expires'));

        if (
          response.headers.get('Cache-Control')?.includes('no-cache') ||
          response.headers.get('Cache-Control')?.includes('no-store')
        ) {
          console.log('✅ index.html is not cached');
        } else {
          console.warn('⚠️ index.html might be cached! Users may see old UI');
        }
      } catch (err) {
        console.error('Error fetching index.html:', err);
      }
    };

    checkIndexCache();
  }, []);

  return (
    <ToastProvider>
      <BrowserRouter>
        <ToastContainer />
        <AuthRouterController />
        <Routes>
          {/* Catch-all route */}
          <Route path="*" element={<NotFound />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/subscribe" element={<PaymentSubsribe />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyViewer />} />
          <Route path="/sign-up" element={<AdminSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route
            path="/landing-page-dashboard"
            element={<LandingPageDashbaord />}
          />

          <Route
            path="/edd"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TrainingGuard>
                    <EDDCustomer />
                  </TrainingGuard>
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/edd-stakeholder/:shareholderId/:shareholderType/:userType/:isShareholder/:shareholderName"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TrainingGuard>
                    <EDDStakeholder />
                  </TrainingGuard>
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/survey"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <SurveyQuestion />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support-tickets"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TicketList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-pricing-plan"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MyPricingPlan />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/:invoiceId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvoiceDetailScreen />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-contract/:customerId/:transactionId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ContractHub />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/role-permission-settings"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <RolePermission />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contract-detail/:customerId/:transactionId/:contractId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ContractDetailsFullScreen />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/generate-report"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReportGenerator />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/document-management"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TemplateDashboard />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-contracts"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ContractList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-template/:templateId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TemplateEditor />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-template"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TemplateCreator />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-document-details/:contractId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <DocumentDetailsOwner />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-template/:contractId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerTemplateViewer />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-agent-contract/:customerId/:transactionId/:contractId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgentTemplateViewer />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reassign-agent-contract/:customerId/:transactionId/:contractId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgentContractReassign />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitoring"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <OngoingMonitoringModule />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/survey-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <SurveyList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MultiStepSidebarForm />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding-shareholder/:shareholderId/:shareholderType/:userType/:isShareholder/:shareholderName"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MultiStepSidebarFormShareholder />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MyProfile />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact-us"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ContactUs />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificate/shared/:token"
            element={<CertificateEntry />}
          />
          {/* <Route
            path="/certificate/shared/:token"
            element={
                  <CertificateEntry />
            }
          /> */}
          <Route
            path="/certificate-action/:externalToken"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CertificateAction />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/certificate-action"
            element={
                  <CertificateAction />
            }
          /> */}
          <Route
            path="/compliance-officer"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ComplianceOfficer />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/auditor-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AuditorList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <DashboardDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/training"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <StaffTraining />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKyc />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/transaction/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TransactionsSection />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc/read-only/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-team-member/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycAgent />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-jointaccount/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycJointAccount />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-jointaccount-read-only/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycJointAccountReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCCorporate />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate/read-only/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCCorporateReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-trust/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCTrust />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-trust/read-only/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCTrustReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate-shareholder/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholder />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate-shareholder-read-only/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholderReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-trust-shareholder/:customerId/:parentId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholderTrust />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-trust-shareholder-read-only/:customerId/:parentId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholderTrustReadOnly />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerList component="" />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/people-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <PeoplePage />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MemberList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificates"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Certificates />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-details/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/compliance-details/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ComplianceDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/auditor-details/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AuditorDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <BusinessList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-details/:customerId/:customerPrevId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <BusinessDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-owner-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgencyList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/agency-details/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgencyDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-member-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgentList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-member-details/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AgentDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/risk-assessment"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <RiskAssessmentQuestionManagement />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
